import { AnyAction } from 'redux'
import { UNLOCK_ORDER } from './index'

export interface UnlockPageUI {
  displayTripInfo: boolean
  countdownTick: number | null
  showFinalCountdown: boolean
}

export const initialState: UnlockPageUI = {
  displayTripInfo: false,
  countdownTick: null,
  showFinalCountdown: false,
}

export const SET_DISPLAY_TRIP_INFO = 'SET_DISPLAY_TRIP_INFO'
export const setDisplayTripInfo = (status: boolean): AnyAction => ({
  type: SET_DISPLAY_TRIP_INFO,
  status,
})

export const SET_FINAL_COUNTDOWN = 'SET_FINAL_COUNTDOWN'
export const setFinalCountdown = (status: boolean): AnyAction => ({
  type: SET_FINAL_COUNTDOWN,
  status,
})

export const SET_COUNTDOWN_TICK = 'SET_COUNTDOWN_TICK'
export const setCountdownTick = (value: number): AnyAction => ({
  type: SET_COUNTDOWN_TICK,
  value,
})

const unlockPageUIReducer = (
  currentState: UnlockPageUI = initialState,
  action: AnyAction,
): UnlockPageUI => {
  switch (action.type) {
    case UNLOCK_ORDER:
      return Object.assign({}, currentState, { showFinalCountdown: true })
    case SET_DISPLAY_TRIP_INFO:
      return Object.assign({}, currentState, { displayTripInfo: action.status })
    case SET_FINAL_COUNTDOWN:
      return Object.assign({}, currentState, {
        showFinalCountdown: action.status,
      })
    case SET_COUNTDOWN_TICK:
      return Object.assign({}, currentState, { countdownTick: action.value })
    default:
      return currentState
  }
}

export default unlockPageUIReducer
